import React from 'react';
import SIcon from './SIcon';
import { faTimesSquare } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faTimesSquare} fa />;

export default Icon;
